import React, { useLayoutEffect, useState } from 'react';
import cn from 'classnames';
import { Types } from '@fiverr-private/theme';
import { Container } from '@fiverr-private/layout_components';
import * as classes from './style.ve.css';

interface BlurredImageProps extends Types.ContainerProps {
    src: string;
    fallbackSrc: string;
    alt?: string;
}

export const BlurredImage = ({ src, fallbackSrc, alt, ...props }: BlurredImageProps) => {
    const [loading, setLoading] = useState(true);

    useLayoutEffect(() => {
        setLoading(true);
    }, [src]);

    return (
        <Container {...props} className={classes.wrapper} style={{ backgroundImage: `url('${fallbackSrc}')` }}>
            <img
                onLoad={() => setLoading(false)}
                src={src}
                alt={alt}
                className={cn(classes.image, { [classes.transparent]: loading })}
            />
        </Container>
    );
};
